<script>

  import { API, to } from "@utils/api.js";
	import Modal from "@components/Modal.svelte";
  import { onMount, onDestroy } from "svelte";
  import { Topic, MentorshipContent } from "@Store";
	import dayjs from 'dayjs' // ES 2015
	import relativeTime from "dayjs/plugin/relativeTime";
  import BookmarkItem from "@components/VideoBookmark.svelte"

  dayjs.extend(relativeTime);

  let createNote = null;
	let savingNote = false;

  let notesShowing = false;

  export let content;
  export let type = 'topic'
  export let player = jwplayer();
  export let user;

  let bookmarkContainer;
  let bookmarksObjects = [];
  let bookmarksList = null;

  let metadata = null;

  let userDiv;

  let showGeneratedNotes = false;

  let Service = type == 'topic' ? Topic : MentorshipContent;
  let watermarkInterval;

  onMount(()=>{
    content.loaded = true;
    $Service = content;

    player.on('loadedmetadata',function(data){
      metadata = {duration:player.duration()}

      if(bookmarksList){
        setBookmarks(bookmarksList)
      }
    })

    if(content.protected){
      player.addEventListener('load', ()=>{
        showGeneratedNotes = true
      })
    }
    watermarkInterval = setInterval(setWatermark,4000);

    bookmarkContainer = document.querySelector('.vjs-progress-control');

  });

  function setWatermark(){
    let p = document.querySelector("#video-player");
    if(!p) return;
    let ww = p.clientWidth;
    let wh = p.clientHeight;
    if(wh == 0) {
      wh = window.innerHeight;
    }

    var posx = Math.round(Math.random() * ww)-20;
    var posy = Math.round(Math.random() * wh)-20;
    userDiv.style.top =  posy + "px";
    userDiv.style.left =  posx + "px";
  }

  function generateNotes(){

  }

  export function setBookmarks(bookmarks){

    bookmarksObjects.forEach(item => {
      item.$destroy()
    });

    bookmarksList = bookmarks;

    if(metadata){
      bookmarks.forEach((item, i) => {
        item.position = (Number(item.video_time) / metadata.duration * 100)

        bookmarksObjects[i] = new BookmarkItem({
          target: bookmarkContainer,
          props: {
            data:item
          }
        })
      });
    }

  }

	export function addNote(position) {
		createNote = {
			video_time:position
		}
    player.pause();
    let wrapper = document.querySelector('.vc-container .html5-video-player > div');
    if(wrapper){
      wrapper.classList.add('force-show')
    }
	}

	function closeNote() {
		createNote = false;
    let wrapper = document.querySelector('.vc-container .html5-video-player > div');
    if(wrapper){
      wrapper.classList.remove('force-show')
    }
	}


	async function deleteNote(note){
		if(confirm("Are you sure you want to delete the note?")){
			let [error,response] = await to(Service.removeNote({
				cuid:$Service.cuid,
				note:note.cuid
			}));
			if(error){
				alert("There was an error deleting the note. Please contact support.")
			}
			response.loaded = true;
			$Service = response;
      // window.dispatchEvent(new CustomEvent('notesupdated',{
      //   detail:response.notes
      // }))
      setBookmarks(response.notes)
		}
	}


	async function saveNote() {
		let update = false;
		if(!createNote.notes) {
			alert("Please enter a note message.")
			return;
		}
    if(!createNote.title) {
			alert("Please enter a valid note title")
			return;
		}

		savingNote = true;
		if(createNote.cuid){
			createNote.note_cuid = createNote.cuid;
			update = true;
		}
		createNote.cuid = content.cuid;
		let error,response;
		if(update){
			[error,response] = await to(Service.updateNote(createNote));
		}else{
			[error,response] = await to(Service.saveNote(createNote));
		}

		savingNote = false;

		if(error){
			alert("Error saving note; Please contact info@impactfx.club for support.")
			return;
		}
		response.loaded = true;
		createNote = false;
    // window.dispatchEvent(new CustomEvent('notesupdated',{
    //   detail:response.notes
    // }));

    setBookmarks(response.notes)

    $Service = response;

	}


	export function editNote(note) {
		createNote = note;
	}

	export function jumpToNote(note) {
		player.currentTime(note.video_time);
    notesShowing = false;
	}

  function onKeyDown(event){
    if(event.key == '/' || event.key == '?' || event.key == 'f' || event.key == 'F' || event.key == ' ' || event.code == 'Space' || event.key == 'ArrowLeft' || event.key == 'ArrowRight'){
      event.stopPropagation()
    }
  }

  onDestroy(()=>{
    clearInterval(watermarkInterval);
  })


</script>

<style type="text/scss">

$size: 200px;

.x {
  /*animation: x 30s linear infinite alternate;*/
  position:absolute;
  z-index: 1000000000;
}

.y {
  /*animation: y 20s linear infinite alternate;*/
}

@keyframes x {
  100% {
    transform: translateX( calc(100vw - #{$size}) );
  }
}

@keyframes y {
  100% {
    transform: translateY( calc(100vh - #{$size}) );
  }
}

.notes {
	position: absolute !important;
  top: 0 !important;
	left: 0 !important;
	width: 260px !important;
	height: 100% !important;
	background: #2f373e !important;
	box-shadow: 10px 0 10px 0px rgba(0,0,0, .1) !important;
	transform:translateX(-110%) !important;
	transition:transform ease-out .3s !important;
  pointer-events: auto !important;
  font-size:18px;
	&.active {
		transform:translateX(0) !important;
	}
}

.note-btn {
  background: #6b95ff !important;
  border-radius: 0 !important;
  color: #fff !important;
  left: 0px !important;
  padding: 8px !important;
  pointer-events: auto !important;
  position: absolute !important;
  top: 0px !important;
  width: 130px!important;
  font-size: 16px;
  font-weight: bold;
}

.generatedNotes {
  bottom: 10px;
  height: 40px;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 100;
  pointer-events: none;

  li {
    color: #0045ff;
    position: absolute;
    font-size: 20px;
    pointer-events: auto;
  }
}
:global([aria-label][class*=cooltipz]:after, [aria-label][data-cooltipz-dir]:after){
  white-space:pre-wrap !important;
}

textarea, input {
  font-size:16px;
  color:black;
  padding:5px;
  width:calc(100% - 30px);
}

.add-bookmark {
  bottom: 4px!important;
  font-size: 20px!important;
  position: absolute!important;
  right: 80px!important;
  z-index: 1000;
}

/*
textarea {
    --tw-shadow: 0 0 #0000 !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important;
    background-color: #fff !important;
    border-color: #6b7280 !important;
    border-radius: 0 !important;
    border-width: 1px !important;
    font-size: 1rem !important;
    line-height: 1.5rem !important;
    padding: 0.5rem 0.75rem !important;
}*/

:global(.vc-container .html5-video-player > div.force-show){
  display:block!important;
}

.name{
  color: #f35626;
  background-image: -webkit-linear-gradient(92deg,#f35626,#feab3a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: hue 60s infinite linear;
  opacity:0.4;
  font-size:20px;
}
@keyframes hue {
    from {
      -webkit-filter: hue-rotate(0deg);
    }

    to {
      -webkit-filter: hue-rotate(360deg);
    }
}

</style>

{#if $Service.loaded}
<div class="x" bind:this={userDiv}>
  <div class="y"><div class="name">{user}</div></div>
</div>
<div on:click={e=>{notesShowing = true}} class="note-btn text-white mb-3 cursor-pointer hover:text-gray-700" style="pointer-events:auto"> <i class="fa-solid fa-bookmark"></i> {notesShowing ? 'Close' : 'Open'}  Notes </div>

<div class="notes !pointer-events-auto" class:active={notesShowing}>
  <h2 class="text-white !text-center !flex !items-center !px-3 !py-2" style="border-bottom: 1px solid #121b22;background: #242b32;">Topic Notes <i class="ml-auto fa-solid fa-arrow-left" on:click={e=>{notesShowing = false}}></i></h2>
  <ul role="list" class="divide-y divide-gray-600 overflow-y-auto" style="height: calc(100% - 47px);">
    {#each $Service.notes as note, i(note.cuid)}
      <li class="!py-4 !text-white !px-3">
        <div class="!flex !space-x-3">
          <div class="!flex-1 !space-y-1">
            <div class="!flex !items-center !justify-between">
              <h3 class="!text-sm !font-medium">{note.title}</h3>
              <div class="!flex !items-center ">
                <p class="!text-xs !text-gray-400">{dayjs().to(dayjs(note.created,true))}</p>
              </div>
            </div>
            <p class="!text-sm !text-gray-400">{@html note.notes.split('\r\n').join('<br/>')}</p>
          </div>
        </div>

        <div class="!flex !w-full !items-center  !mt-2 ">
          <span on:click={e=>{jumpToNote(note)}} style="background: #252c32;" class="flex cursor-pointer items-center justify-center w-full text-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-700 text-gray-400"> Jump To Note </span>
          <i on:click={e=>{editNote(note)}} class="cursor-pointer fa-solid fa-pencil ml-3 text-sm text-gray-400 "></i>
          <i on:click={e=>{deleteNote(note)}} class="cursor-pointer fa-solid fa-trash-can ml-3 text-sm text-gray-400 "></i>
        </div>

      </li>
    {/each}
  </ul>
</div>
{/if}

{#if showGeneratedNotes}
<div class="generatedNotes">
  <ul class='w-full absolute'>
    {#each $Service.notes as note, i(note.cuid)}
    <li on:click={e=>{jumpToNote(note)}} class="custom--medium" data-cooltipz-dir="top" data-cooltipz-size="medium" aria-label="{note.notes.split('\r\n').join('\n')}" style="left:{(note.video_time / player.duration * 100).toFixed(2)}%"><i class="fa-duotone fa-circle-dot"></i></li>
    {/each}
  </ul>
</div>

<button on:click={e=>addNote(player.currentTime)} class="add-bookmark custom--medium" data-cooltipz-dir="top" data-cooltipz-size="medium" aria-label="Add Bookmark"><i class="fa-duotone fa-bookmark"></i></button>
{/if}

<Modal id="note-modal" on:close={closeNote} open={createNote} style="background:white; pointer-events:auto;width:300px;position:absolute; top:50%; left:50%; transform:translate(-50%,-50%)">
  <svelte:fragment slot="title">
    <h1 class="!text-xl !text-black !font-bold">{createNote.cuid ? 'Edit' : 'Add' } Video Note</h1>
  </svelte:fragment>
  <svelte:fragment slot="content">
  <div class="!mb-3">
    <label for="title" class="!block !text-sm !font-medium !text-gray-700">Note Title</label>
    <div class="mt-1">
      <input on:keydown={onKeyDown} type="text" bind:value={createNote.title} name="title" id="title" class="!shadow-sm !focus:ring-indigo-500 !focus:border-indigo-500 !block !w-full !sm:text-sm !border-gray-300 !rounded-md" placeholder="">
    </div>
  </div>
    <div>
      <label for="comment" class="!block !text-sm !font-medium !text-gray-700">Add your note</label>
      <div class="mt-1">
        <textarea on:keydown={onKeyDown} bind:value={createNote.notes} rows="4" name="comment" id="comment" class="!shadow-sm !focus:ring-indigo-500 !focus:border-indigo-500 !block !w-full !sm:text-sm !border-gray-300 !rounded-md"></textarea>
      </div>
    </div>
    <button on:click={saveNote} type="button" class="!mt-3 !inline-flex !items-center !px-3 !py-2 !border !border-transparent !text-sm !leading-4 !font-medium !rounded-md !shadow-sm !text-white !bg-black !hover:bg-gray-700 !focus:outline-none !focus:ring-2 !focus:ring-offset-2 !focus:ring-blue-500">{savingNote ? 'Saving...':'Save Note'}</button>
  </svelte:fragment>
</Modal>
